import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

import Image from 'components/Common/Image'
import BodyText from 'components/Luxkit/Typography/BodyText'

type Props = {
  brand: Tours.V2OfferBrand
}

const OperatorLogoContainer = styled.div`
  display: block;
  flex-shrink: 0;
  max-height: ${rem(75)};
  max-width: ${rem(150)};
`

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

function TourV2Operator({ brand }: Props) {
  const operatorLogo = brand.logoImage
  return (
    <Container>
      <div>
        <BodyText variant="medium" weight="semi-bold">
          Operated By
        </BodyText>
        <BodyText variant="large">{brand.name}</BodyText>
      </div>
      {operatorLogo && (
        <OperatorLogoContainer>
          <Image
            id={operatorLogo.id}
            dpr={2}
            quality="eco"
            width={150}
            alt={operatorLogo.title}
            aria-hidden="true"
          />
        </OperatorLogoContainer>
      )}
    </Container>
  )
}

export default TourV2Operator
